import { registerRootComponent } from "expo";
import React from "react";
import App from "app/App.js";

class AppEntry extends React.Component {
  render() {
    return <App />;
  }
}

registerRootComponent(AppEntry);

// import { AppRegistry, Platform } from "react-native";
// import App from "./App";

// AppRegistry.registerComponent("main", () => App);

// if (Platform.OS === "web") {
//   const rootTag =
//     document.getElementById("root") || document.getElementById("main");
//   AppRegistry.runApplication("main", { rootTag });
// }
